import { render, staticRenderFns } from "./CodeSample.vue?vue&type=template&id=3cfe79da&scoped=true"
import script from "./CodeSample.vue?vue&type=script&lang=ts"
export * from "./CodeSample.vue?vue&type=script&lang=ts"
import style0 from "./CodeSample.vue?vue&type=style&index=0&id=3cfe79da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe79da",
  null
  
)

export default component.exports